import { Timeline } from '@dev-spendesk/grapes';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { TimelineItem } from 'common/components/Timeline';
import { useTranslation } from 'common/hooks/useTranslation';
import { useCompanyCurrency } from 'modules/app/hooks/useCompanyCurrency';
import { getI18nContext } from 'src/core/selectors/i18n';
import { reverseChronologicalDateComparator } from 'src/core/utils/date';
import { formatTimelineEvents } from 'src/core/utils/timelines';

import { type TransferDetails } from '../../../../models';

type Props = {
  transfer: TransferDetails;
};

export const TransferTimeline = ({ transfer }: Props) => {
  const { t } = useTranslation('global');
  const companyCurrency = useCompanyCurrency();
  const i18nContext = useSelector(getI18nContext);
  const { timeline, request } = transfer;

  const timelineEvents = useMemo(() => {
    const formattedEvents = formatTimelineEvents(
      t,
      timeline,
      request,
      companyCurrency,
      i18nContext,
    );

    return formattedEvents
      .map((timelineEvent) => ({
        key: timelineEvent.id,
        date: new Date(timelineEvent.occuredAt),
        content: (
          <TimelineItem key={timelineEvent.id} timelineEvent={timelineEvent} />
        ),
      }))
      .sort(({ date: dateA }, { date: dateB }) =>
        reverseChronologicalDateComparator(dateA, dateB),
      );
  }, [transfer]);

  return (
    <Timeline className="mt-24">
      {timelineEvents.map((timelineEvent) => timelineEvent.content)}
    </Timeline>
  );
};
